import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {API_PATH} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionPasserService} from '../../services/question-passer-service';
import {DamageQuestionPasser} from '../../services/damage-question-passer';
import {getParam} from '../question-helper';

declare var $: any;

@Component({
    selector: 'app-question-uploader-variation-one',
    templateUrl: './question-uploader-variation-one.component.html',
    styleUrls: ['./question-uploader-variation-one.component.scss'],
    standalone: false
})
export class QuestionUploaderVariationOneComponent implements OnInit {

  @Input() question: Question;
  @Input() showNoShadow = false;
  @Output() questionAnswer = new EventEmitter();

  subscription: Subscription;
  dropZone: any;
  acceptedFileTypes = 'image/*';
  savedResources: any[] = [];
  skipped = false;
  showSkip = false;
  parameter: any;
  uploadedFiles: any[] = [];

  constructor(
    private questionPasserService: QuestionPasserService,
    private damagePasserService: DamageQuestionPasser,
    private globalQuestionService: GlobalQuestionService
  ) {
    this.subscription = this.questionPasserService.updateComponent()
      .subscribe((question: Question) => {
        if (!question) {
          return;
        }
        this.damagePasserService.setDamageImageModalAlt(false);
        if (question.cent_aq_question_id === this.question?.cent_aq_question_id) {
          this.loadUploadedFiles();
        }
        this.questionAnswer.emit(question);
      });
  }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
    this.loadUploadedFiles();
  }

  loadUploadedFiles(): void {
    this.uploadedFiles = [];
    if (!this.question?.answer) {
      return;
    }
    let resources: any[];
    try {
      resources = JSON.parse(JSON.parse(this.question.answer)?.resources);
    } catch (e) {
      return;
    }
    resources?.forEach((res: any) => {
      const resource_id = res?.resource_id;
      if (!resource_id) {
        return;
      }
      this.globalQuestionService.getUploadedFileDetails(resource_id)
        .subscribe((details: any) => {
          this.uploadedFiles.push({
            resource_id,
            name: details?.[0]?.original_filename,
            url: `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`
          });
        });
    });
  }

  removeUploadedFile(resource_id: string): void {
    this.globalQuestionService.removeFile(resource_id).subscribe(() => {
      this.uploadedFiles = this.uploadedFiles.filter(f => f.resource_id !== resource_id);
      try {
        const response = JSON.parse(this.question.answer);
        const resources = (JSON.parse(response?.resources) || []).filter((r: any) => r?.resource_id !== resource_id);
        this.question.answer = resources.length ? JSON.stringify({...response, resources: JSON.stringify(resources)}) : '';
      } catch (e) {
        this.question.answer = '';
      }
      this.questionAnswer.emit(this.question);
    });
  }

  onClick(): void {
    this.questionPasserService.passQuestion(this.question);
    this.damagePasserService.setDamageImageModalAlt(true);
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }

}
